import "./modules/common";
import Vue from "vue";
import VueApp from "~/Scripts/new/vueApp";
import ProductPricing from "~/Components/Product/ProductPricing.vue";
import LoginForm from "~/Components/Accounts/LoginForm.vue";
import ProductImagesWrapper from "~/Components/Product/ProductImagesWrapper.vue";
import ProductPricingButtons from "~/Components/Product/ProductPricingButtons.vue";
import idPlugin from "~/Scripts/plugins/idPlugin";

Vue.use( idPlugin );

new VueApp( {
  name: "ProductItem",
  components: {
    ProductPricing,
    ProductImagesWrapper,
    ProductPricingButtons,
    LoginForm
  },

  data () {
    return {
      showPriceOnApplication: false,
      showRegisterInterest: false
    };
  },

  methods: {
    onPriceOnApplicationChange ( val ) {
      this.showPriceOnApplication = val;
    },
    onRegisterInterestChange ( val ) {
      this.showRegisterInterest = val;
    }
  }
} );
